import { render, staticRenderFns } from "./ClickItem.vue?vue&type=template&id=295e0850&scoped=true&"
import script from "./ClickItem.vue?vue&type=script&lang=ts&"
export * from "./ClickItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e0850",
  null
  
)

export default component.exports